export default {
  courierLevelDesc: '/clientEcosys/courierLevel/courierLevelDesc'
}
